import React from "react";
import { DataTable, Table } from "@sscs/ui";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFocusedRow, } from "../../../store/networkingSlice";
import { ExpandedRowDetails } from "../../../ui";
import { NetworkingServicesList, NetworkingUrlValue, PolicyAudit, } from "../../common";
import { useReportDispatch, useReportSelector } from "../../hooks";
import ComponentListTable from "./ComponentListTable";
import styles from "./networkingRow.module.scss";
const NetworkingRow = ({ rowIndex, networking, searchRegex, }) => {
    var _a, _b;
    var _c;
    const dispatch = useReportDispatch();
    const expanded = useReportSelector((state) => selectExpandedRow(state, networking.id));
    const focusedRow = useReportSelector(selectFocusedRow);
    const hasAudit = networking.audit.present;
    const hasServices = networking.services.length > 0;
    const hasComponents = networking.component_count > 0;
    return (React.createElement(DataTable.ExpandedRow, { id: `networking-expand-row-${rowIndex}`, disabled: !hasAudit && !hasServices && !hasComponents, expanded: expanded, onChange: (isExpanded) => dispatch(expandedRowsUpdated({ id: networking.id, expand: isExpanded })), focused: focusedRow === networking.id, onClick: () => dispatch(focusedRowUpdated(networking.id)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, { className: styles["uri-tag"] },
                React.createElement(NetworkingUrlValue, { value: networking.value, classification: (_c = (_a = networking.classification) === null || _a === void 0 ? void 0 : _a.classification) !== null && _c !== void 0 ? _c : "", servicesCount: networking.services.length, searchRegex: searchRegex })),
            React.createElement(Table.Cell, null, ((_b = networking.classification) === null || _b === void 0 ? void 0 : _b.result)
                ? networking.classification.result
                : "--"),
            React.createElement(Table.Cell, { className: styles["uri-tag"] }, [...networking.tags].sort().map((tag) => (React.createElement("div", { key: tag }, tag)))),
            React.createElement(Table.Cell, null, networking.component_count.toLocaleString())),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                (hasAudit || hasServices) && (React.createElement(ExpandedRowDetails.Aside, null,
                    hasAudit && React.createElement(PolicyAudit, { audit: networking.audit }),
                    hasServices && (React.createElement(NetworkingServicesList, { services: networking.services })))),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(ComponentListTable, { networking: networking, rowIndex: rowIndex }))))));
};
export default NetworkingRow;
//# sourceMappingURL=NetworkingRow.js.map